export default {
  container: 'rounded-md p-4 m-3',
  iconWrapper: 'flex-shrink-0',
  message: 'text-sm font-interMedium text-color-white',
  buttonMainWrapper: 'ml-auto pl-3',
  buttonWrapper: '-mx-1.5 -my-1.5',
  button: 'inline-flex rounded-md p-1.5 bg-color-white hover:bg-[#E3E3E3]',
};
